import { createSelector } from '@ngrx/store';
import { CollectionsState, getCollectionsState } from '../collections.reducer';

export const getNotesState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.notes,
);

export const getCurrentPageNumber = createSelector(getNotesState, ({ pageNumber }) => pageNumber);

export const getMoreElements = createSelector(getNotesState, ({ moreElements }) => moreElements);
